import { IntervalUnit } from './Bundle'
import { SegmentTarget } from './Campaign'
import { PostalCodeTarget } from './Geo'

export interface MasterCampaignStub {
  id: string
  accountId: string
  organizationId: string
  masterCampaignPlanId: string
  name: string
  campaignBuilders: MasterCampaignPlanCampaignBuilder[]
  created: Date
  createdBy: string
  updated: Date
  updatedBy: string
}

export interface MasterCampaignPlanCampaignBuilder {
  id: string
  name: string
  segmentTargets: SegmentTarget[]
  shortSummary: string
  longSummary: string
  audienceSummary: string
  geoSummary: string
  seasonalitySummary: string
  campaignType: MasterCampaignPlanCampaignBuilderType
  isOffAdCritter?: boolean
  offAdCritterName?: string
  offAdCritterColor?: string
  intervalBudget: number
  retargetSite: boolean
  isTotalBudget: boolean
  startDate: moment.Moment
  endDate?: moment.Moment
  intervalUnit?: IntervalUnit
  intervalFrequency?: number
  intervalDuration?: number
  audienceSegmentLooksUp?: string[]
  targetingType?: MasterCampaignStubLocationType
  regions?: string[]
  dmas?: string[]
  cities?: string[]
  zips?: PostalCodeTarget[]
  transferredToDspDate?: moment.Moment
  dspCampaignId?: string
  transferStatus?: CampaignTransferStatus
  cpm?: number
  marginOfError?: number
  minCpm?: number
  maxCpm?: number
  includeInProjections?: boolean
  includeInGeoHeatmap?: boolean
}

export enum MasterCampaignPlanCampaignBuilderType {
  Internet = 'Internet',
  Billboard = 'Billboard',
  TV = 'TV',
  Audio = 'Audio',
  OffAdCritter = 'OffAdCritter'
}

export enum MasterCampaignStubLocationType {
  Region = 'Region',
  Country = 'Country',
  DMA = 'DMA',
  City = 'City',
  Zip = 'Zip',
  Map = 'Map',
  Address = 'Address',
  Uploaded = 'Uploaded',
  USA = 'Usa'
}

export enum CampaignTransferStatus {
  NotTransferred = 'NotTransferred',
  Transferred = 'Transferred'
}